/**
 * Picks v2 or v1 of the Card Decks list page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CardDecksMainPage   from './CardDecksMainPage';
import CardDecksMainPageV2 from './v2/CardDecksMainPageV2';

export default function CardDecksMainPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CardDecksMainPageV2 : CardDecksMainPage;
  return <Component {...props} />;
}
